import { Action, CustomTagType, DockType, OperationType, Position, UpdateDialogScope, WindowType } from "puzzle";
import PopupLanguages from "../components/Submission/sections/Popups/Languages/PopupLanguages";
import InstructionsPopup from "../components/Submission/sections/Popups/Instructions/InstructionsPopup";
import CustomFieldsPopup from "../components/Submission/sections/Popups/CustomFields/CustomFieldsPopup";
import ContentPopup from "../components/Submission/sections/Popups/Content/ContentPopup";

export const openSubmissionPopup: Action = [{
  condition: '{popupName}',
  languages: [{
    name: 'languagesPopup',
    type: OperationType.action
  }],
  instructions: [{
    name: 'instructionsPopup',
    type: OperationType.action
  }],
  customFields: [{
    name: 'customFieldsPopup',
    type: OperationType.action
  }],
  content: [{
    name: 'contentPopup',
    type: OperationType.action
  }],
  type: OperationType.switch
}];


export const languagesPopup: Action = [{
  persistent: ['submissionMode'],
  type: OperationType.addPersistentData,
}, {
  moduleName: 'Details',
  name: 'getData',
  mappingName: 'detailsData',
  type: OperationType.addOperationData
}, {
  title: 'submissionPopupDialogs.languages',
  children: [{
    render: PopupLanguages,
    propArgs: ['detailsData', 'detailsProps', 'detailsState']
  }],
  className: 'md submission-popup preview-languages',
  closable: true,
  items: [{
    btnName: 'submissionPopupDialogs.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'exitLanguagesPopup',
      type: OperationType.action
    }]
  }, {
    btnName: 'submissionPopupDialogs.save',
    close: false,
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    operations: [{
      moduleName: 'PopupLanguages',
      name: 'hasDataChange',
      type: OperationType.addOperationData
    }, {
      condition: '{hasDataChange}',
      conditionOperations: [{
        moduleName: 'PopupLanguages',
        name: 'getLanguagesData',
        type: OperationType.addOperationData
      }, {
        moduleName: 'Details',
        name: 'populateWithPopupData',
        args: ['getLanguagesData']
      }, {
        moduleName: 'PopupLanguages',
        name: 'getSelectedTargetLanguages',
        mappingName: 'referenceFilesLanguages',
        type: OperationType.addOperationData
      }, {
        data: {
          template: {
            bind: {
              selectedTargetLanguages: '{referenceFilesLanguages}'
            }
          }
        },
        type: OperationType.data
      }, {
        name: 'submissionTargetLanguageChange',
        type: OperationType.action
      }, {
        name: 'exitLanguagesPopup',
        type: OperationType.action
      }],
      elseOperations: [{
        name: 'exitLanguagesPopup',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }],
  type: OperationType.dialog
}, {
  waitForModule: true,
  moduleName: 'PopupLanguages',
  name: 'setData'
}];

export const exitLanguagesPopup: Action = [{
  persistent: ['submissionMode'],
  type: OperationType.removePersistentData
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const instructionsPopup: Action = [{
  persistent: ['form', 'instructionsData'],
  type: OperationType.addPersistentData,
}, {
  title: 'instructionsPopup.instructionsAndReferenceFiles',
  children: [{
    render: InstructionsPopup,
    propArgs: ['form']
  }],
  className: 'md submission-popup preview-instructions-reference-files',
  items: [{
    btnName: 'instructionsPopup.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'instructionsPopup.save',
    close: false,
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end,
      template: {
        bind: {
          disabled: '{uploadIsInProgress}'
        }
      }
    },
    operations: [{
      moduleName: 'Instructions',
      moduleId: 'PopUpInstructions',
      name: 'hasDataChange',
      args: ['instructionsData'],
      type: OperationType.addOperationData
    }, {
      condition: '{hasDataChange}',
      conditionOperations: [{
        data: {
          template: {
            removeFrom: 'fromInstructionsPopUp'
          }
        },
        moduleName: 'Instructions',
        moduleId: 'PopUpInstructions',
        name: 'getData',
        type: OperationType.addOperationData
      }, {
        name: 'removeFilesOnSave',
        type: OperationType.action
      }, {
        data: {
          template: {
            bind: {
              deletedFiles: '{getData.deletedReferenceFiles}'
            }
          }
        },
        moduleName: 'DropUpload',
        moduleId: 'fromInstructions',
        name: 'setDeletedFiles',
        args: ['deletedFiles']
      }, {
        data: {
          template: {
            instructionsHtml: {
              bind: {
                instructions: '{getData}'
              }
            }
          }
        },
        moduleName: 'Instructions',
        name: 'setData',
        args: ['getData']
      }, {
        data: {
          template: {
            forceAdd: true,
            moduleId: 'fromInstructions',
            details: {
              bind: {
                project: '{form.getData().project}',
                targetLanguage: '{form.getData().targetLanguage}'
              }
            },
            bind: {
              referenceFiles: '{getData.referenceFiles}',
              languages: '{initializeUserData.languages}'
            }
          },
        },
        type: OperationType.data
      }, {
        name: 'moveInstructionsFiles',
        type: OperationType.action
      }, {
        name: 'exitInstructions',
        type: OperationType.action
      }],
      elseOperations: [{
        name: 'exitInstructions',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }],
  type: OperationType.dialog
}, {
  waitForModule: true,
  moduleName: 'Instructions',
  moduleId: 'PopUpInstructions',
  name: 'delaySetData',
  args: ['instructionsData']
}, {
  data: {
    template: {
      moduleId: 'fromInstructionsPopUp',
      forceAdd: true,
      details: {
        bind: {
          project: '{form.getData().project}',
          targetLanguage: '{form.getData().targetLanguage}'
        }
      },
      bind: {
        referenceFiles: '{instructionsData.referenceFiles}',
        languages: '{initializeUserData.languages}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'moveInstructionsFiles',
  type: OperationType.action
}];

export const exitInstructions: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  persistent: ['form', 'instructionsData'],
  type: OperationType.removePersistentData,
}];

export const updateInstructionsPopupDialog: Action = [{
  buttons: [{
    name: 'instructionsPopup.save',
    disabled: '{uploadIsInProgress}'
  }],
  scope: UpdateDialogScope.active,
  type: OperationType.updateDialog
}];

export const moveInstructionsFiles: Action = [{
  evaluate: true,
  moduleName: 'DropUpload',
  moduleId: '{moduleId}',
  name: 'setExistingFiles',
  args: ['referenceFiles', 'details', 'languages', 'forceAdd']
}];

export const removeFilesOnSave: Action = [{
  evaluate: true,
  moduleName: 'DropUpload',
  moduleId: '{removeFrom}',
  name: 'getDeletedFilesTickets',
  type: OperationType.addOperationData
}, {
  condition: '{getDeletedFilesTickets.tickets.length > 0}',
  conditionOperations: [{
    data: {
      method: 'post',
      url: '/submissions/delete/temporary',
      template: {
        bind: {
          params: '{getDeletedFilesTickets}'
        }
      }
    },
    type: OperationType.request
  }],
  type: OperationType.conditional
}];

export const customFieldsPopup: Action = [{
  moduleName: 'CustomFields',
  name: 'getData',
  mappingName: 'initValues',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        customAttributesCount: "'(' +{customFieldsState.fields.length} + ')'"
      }
    }
  },
  type: OperationType.data
}, {
  persistent: ['initValues'],
  type: OperationType.addPersistentData,
}, {
  title: 'submissionPopupDialogs.customFields',
  children: [{
    render: CustomFieldsPopup,
    propArgs: ['customFieldsProps']
  }],
  className: 'md submission-popup preview-custom-fields',
  items: [{
    btnName: 'submissionPopupDialogs.cancel',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'closeAndClearData',
      type: OperationType.action
    }]
  }, {
    btnName: 'submissionPopupDialogs.save',
    close: false,
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    operations: [{
      moduleName: 'CustomFields',
      moduleId: 'CustomFieldsPopup',
      name: 'hasDataChange',
      args: ['initValues'],
      type: OperationType.addOperationData
    }, {
      condition: '{hasDataChange}',
      conditionOperations: [{
        moduleName: 'CustomFields',
        moduleId: 'CustomFieldsPopup',
        name: 'getData',
        mappingName: 'popupData',
        type: OperationType.addOperationData
      }, {
        name: 'closeAndClearData',
        type: OperationType.action
      }, {
        moduleName: 'CustomFields',
        name: 'setData',
        args: ['popupData']
      }],
      elseOperations: [{
        name: 'closeAndClearData',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }, {
    btnName: 'customAttributesCount',
    operations: [],
    btnConfig: {
      customTagType: CustomTagType.counter,
      dock: DockType.top,
      args: ['', 'customAttributesCount'],
      pos: Position.start
    }
  }],
  type: OperationType.dialog
}, {
  moduleName: 'CustomFields',
  moduleId: 'CustomFieldsPopup',
  name: 'setFields',
  data: {
    template: {
      bind: {
        customFields: '{customFieldsState.fields}'
      }
    }
  },
  args: ['customFields']
}, {
  waitForModule: true,
  moduleName: 'CustomFields',
  moduleId: 'CustomFieldsPopup',
  name: 'setPopupData',
  args: ['initValues']
}];

export const closeAndClearData: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  persistent: ['initValues'],
  type: OperationType.removePersistentData
}];

export const contentPopup: Action = [{
  data: {
    template: {
      bind: {
        contentUploadedFiles: '{contentProps.uploadedFiles}'
      }
    }
  },
  type: OperationType.data
}, {
  persistent: ['contentUploadedFiles'],
  type: OperationType.addPersistentData
}, {
  title: 'contentPopup.title',
  children: [{
    render: ContentPopup,
    propArgs: ['contentProps']
  }],
  className: 'md submission-popup preview-content',
  items: [{
    btnName: 'contentPopup.cancel',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'exitContentPopup',
      type: OperationType.action
    }]
  }, {
    btnName: 'contentPopup.save',
    close: false,
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    operations: [{
      moduleName: 'DropUpload',
      moduleId: 'fromContentPopUp',
      name: 'getFiles',
      mappingName: 'currentUploadedData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'ContentPopup',
      name: 'hasDataChange',
      args: ['contentUploadedFiles', 'currentUploadedData'],
      type: OperationType.addOperationData
    }, {
      condition: '{hasDataChange}',
      conditionOperations: [{
        moduleName: 'ContentPopup',
        name: 'addUploadedFlag',
        mappingName: 'editedFiles',
        args: ['currentUploadedData'],
        type: OperationType.addOperationData
      }, {
        data: {
          template: {
            moduleId: 'fromContent',
            removeFrom: 'fromContentPopUp',
            submissionFolder: null,
            bind: {
              uploadedFiles: '{editedFiles}'
            }
          }
        },
        type: OperationType.data
      }, {
        name: 'removeFilesOnSave',
        type: OperationType.action
      }, {
        name: 'updateState',
        type: OperationType.action
      }, {
        data: {
          dropUploadModuleId: 'fromContentPopUp'
        },
        name: 'appendDeletedSubmissionFiles',
        type: OperationType.action
      }, {
        name: 'exitContentPopup',
        type: OperationType.action
      }],
      elseOperations: [{
        name: 'exitContentPopup',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }],
  type: OperationType.dialog
}, {
  moduleName: 'DropUpload',
  moduleId: 'fromContent',
  name: 'getSubmissionFolder',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      moduleId: 'fromContentPopUp',
      bind: {
        uploadedFiles: '{contentProps.uploadedFiles}',
        submissionFolder: '{getSubmissionFolder}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'updateState',
  type: OperationType.action
}];

export const updateContentPopupDialog: Action = [{
  buttons: [{
    name: 'contentPopup.save',
    disabled: '{uploadIsInProgress}'
  }],
  scope: UpdateDialogScope.active,
  type: OperationType.updateDialog
}];

export const appendDeletedSubmissionFiles: Action = [{
  evaluate: true,
  moduleName: 'DropUpload',
  moduleId: '{dropUploadModuleId}',
  name: 'getFilesRemovedFromSubmission',
  mappingName: 'removedPopupFiles',
  type: OperationType.addOperationData
}, {
  moduleName: 'DropUpload',
  moduleId: 'fromContent',
  name: 'setDeletedFiles',
  args: ['removedPopupFiles']
}];

export const exitContentPopup: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  persistent: ['contentUploadedFiles'],
  type: OperationType.removePersistentData
}];
